import { JsonProperty } from "@nstep-common/utils";

export class JwtTokenModel {

	@JsonProperty()
	aud!: string;

	@JsonProperty()
	iss!: string;

	@JsonProperty()
	exp!: number;

	@JsonProperty({ name: 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role' })
	role!: string;

	@JsonProperty({ name: 'RoleId', type: Number, nullable: true })
	roleId!: number | null;

	@JsonProperty({ name: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name' })
	name!: string;

	@JsonProperty({ name: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier' })
	nameIdentifier!: string;

	@JsonProperty({ name: 'Access', array: true, type: String })
	access!: string[];

	@JsonProperty({ name: 'SubRole', array: true, type: String })
	subRoles!: string[];

	@JsonProperty({ name: 'ProfileId', type: String, nullable: true })
	profileId!: string | null;

	@JsonProperty({  name: 'ImpersonatedBy', type: String, nullable: true })
	impersonatedBy!: string | null;

	@JsonProperty({  name: 'HasTotalAccount', type: String, nullable: true })
	hasTotalAccount!: string | null;
}